"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paginationTableGroup = exports.paginationTable = exports.paginationItem = exports.pagination = void 0;

var _stylitas = require("@creditas/stylitas");

const pagination = ({
  theme
}) => (0, _stylitas.css)`
  background: ${theme.bColorneutral02};
  height: 48px;
  user-select: none;
  display: flex;
  text-align: center;
  justify-content: center;
`;

exports.pagination = pagination;

const paginationItem = ({
  theme
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.reset.button()}
  display: inline-block;
  height: 48px;
  line-height: ${theme.bTextsupportLineHeight};
  min-width: 48px;
  padding: 12px;

  &:hover,
  &:focus,
  &[data-active='true'] {
    background-color: ${theme.bColorsecondary01};
    cursor: pointer;
  }

  &[data-active='true'] {
    border-bottom: 4px solid ${theme.bColorsecondary05};
    font-weight: 600;
  }

  &.action {
    padding: 8px;
  }
`;

exports.paginationItem = paginationItem;

const paginationTable = ({
  theme
}) => (0, _stylitas.css)`
  background: ${theme.bColorneutral02};
  display: grid;
  grid-template-columns: 160px auto 160px;
  height: 48px;
  user-select: none;
`;

exports.paginationTable = paginationTable;

const paginationTableGroup = ({
  theme
}) => (0, _stylitas.css)`
  font-size: ${theme.bTextsupportFontSize};
  margin: 0 5px;
  text-align: center;

  &:first-of-type {
    line-height: ${theme.bTextsupportLineHeight};
    padding: 12px 16px;
    text-align: left;
  }
`;

exports.paginationTableGroup = paginationTableGroup;